// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Article_container__r\\+mGp {
  display: flex;
  flex-direction: column;
  background-color: var(--color-mima-light);
  padding: 8rem 5rem;
}
.Article_container_cards__WxMXe {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
}
@media only screen and (max-width: 43.75em) {
  .Article_container_cards__WxMXe {
    grid-template-columns: 1fr;
  }
}
.Article_container_card__6Z7Pv {
  background-color: var(--color-white);
  padding: 3rem;
  border-radius: 2rem;
  height: 100%;
}
.Article_container_card__6Z7Pv img {
  object-fit: cover;
  height: 40rem;
  width: 100%;
  border-radius: 1.6rem;
}
.Article_container_title__EnUTJ {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 5rem;
}
.Article_container_img__PjVIn {
  height: 60vh;
  width: 100%;
  object-fit: cover;
  margin-bottom: 3rem;
}
@media only screen and (max-width: 43.75em) {
  .Article_container_img__PjVIn {
    height: 40vh;
  }
}
.Article_container_list__A687y {
  list-style-type: disc;
  padding-left: 5.5rem;
}
@media only screen and (max-width: 31.25em) {
  .Article_container_list__A687y {
    padding-left: 3rem;
  }
}
.Article_container_list__A687y > li {
  font-size: var(--default-font-size);
  line-height: 2.7rem;
  margin-bottom: 2rem;
}
.Article_container_olist__GdEV5 {
  list-style-type: lower-alpha;
  padding-left: 5.5rem;
}
@media only screen and (max-width: 31.25em) {
  .Article_container_olist__GdEV5 {
    padding-left: 3rem;
  }
}
.Article_container_olist__GdEV5 > li {
  font-size: var(--default-font-size);
  line-height: 2.7rem;
  margin-bottom: 2rem;
}

.Article_slide__Q3TM- {
  margin-top: 10rem;
  display: grid;
  grid-template-columns: repeat(2, max-content);
  justify-content: center;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .Article_slide__Q3TM- {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3rem;
    margin-top: 4rem;
  }
}
.Article_slide__text__yPUhm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 65rem;
  padding-right: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Article_slide__text__yPUhm {
    text-align: center;
  }
}
.Article_slide__text_btn__PGvXH {
  display: flex;
  gap: 2rem;
  height: 2.2rem;
  margin: 8rem 0;
  align-self: center;
}
@media only screen and (max-width: 62.5em) {
  .Article_slide__text_btn__PGvXH {
    justify-content: center;
  }
}
@media only screen and (max-width: 37.5em) {
  .Article_slide__text_btn__PGvXH {
    flex-direction: column;
    align-items: center;
  }
}
.Article_slide__img__bOiu6 {
  width: 58rem;
}
@media only screen and (max-width: 62.5em) {
  .Article_slide__img__bOiu6 {
    width: 40rem;
  }
}

.Article_btn__icon__oHXr1 {
  height: 2.2rem;
}

.Article_related__jV178 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 50em) {
  .Article_related__jV178 {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Article_related__jV178 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 25em) {
  .Article_related__jV178 {
    grid-template-columns: 1fr;
  }
}
.Article_related__card__gi7lA {
  background-color: var(--color-white);
  padding: 2rem;
  border-radius: 1.6rem;
  cursor: pointer;
  height: 100%;
}
.Article_related__card__gi7lA:hover {
  background-color: var(--color-primary-3);
}
.Article_related__card__gi7lA img {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/Article.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,yCAAA;EACA,kBAAA;AADJ;AAGI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;AADR;AAGQ;EALJ;IAMQ,0BAAA;EAAV;AACF;AAII;EACI,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAFR;AAIQ;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;AAFZ;AAUI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AARR;AAWI;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AATR;AAWQ;EANJ;IAOQ,YAAA;EARV;AACF;AAWI;EACI,qBAAA;EACA,oBAAA;AATR;AAWQ;EAJJ;IAKQ,kBAAA;EARV;AACF;AAUO;EACC,mCAAA;EACA,mBAAA;EACA,mBAAA;AARR;AAWI;EACI,4BAAA;EACA,oBAAA;AATR;AAWQ;EAJJ;IAKQ,kBAAA;EARV;AACF;AAUO;EACC,mCAAA;EACA,mBAAA;EACA,mBAAA;AARR;;AAaA;EACC,iBAAA;EACA,aAAA;EACA,6CAAA;EACA,uBAAA;EACA,sBAAA;AAVD;AAYC;EAPD;IAQE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;EATA;AACF;AAWC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AATF;AAWE;EAPD;IAQE,kBAAA;EARD;AACF;AAUE;EACC,aAAA;EACA,SAAA;EACS,cAAA;EACA,cAAA;EACA,kBAAA;AARZ;AAUG;EAPD;IAQE,uBAAA;EAPF;AACF;AAQG;EAVD;IAWE,sBAAA;IACA,mBAAA;EALF;AACF;AAUC;EACC,YAAA;AARF;AAUE;EAHD;IAIE,YAAA;EAPD;AACF;;AAYC;EACC,cAAA;AATF;;AAaA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AAVJ;AAYI;EALJ;IAMQ,qCAAA;EATN;AACF;AAWI;EATJ;IAUQ,qCAAA;EARN;AACF;AAUI;EAbJ;IAcQ,0BAAA;EAPN;AACF;AASI;EACI,oCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AAPR;AASQ;EACI,wCAAA;AAPZ;AAWQ;EACI,WAAA;AATZ","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n    display: flex;\n    flex-direction: column;    \n    background-color: var(--color-mima-light);\n    padding: 8rem 5rem;\n\n    &_cards {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 3rem;\n\n        @media only screen and (max-width: $bp-700) {\n            grid-template-columns: 1fr;\n        }\n\n    }\n\n    &_card {\n        background-color: var(--color-white);\n        padding: 3rem;\n        border-radius: 2rem;\n        height: 100%;\n\n        img {\n            object-fit: cover;\n            height: 40rem;\n            width: 100%;\n            border-radius: 1.6rem;\n\n            // @media only screen and (max-width: $bp-800) {\n            //     height: 60rem;\n            // }\n        }\n    }\n\n    &_title {\n        display: flex;\n        flex-direction: column;\n        align-items: center;   \n        width: 100%;  \n        margin-bottom: 5rem;\n    }\n\n    &_img {\n        height: 60vh;\n        width: 100%;\n        object-fit: cover;\n        margin-bottom: 3rem;\n\n        @media only screen and (max-width: $bp-700) {\n            height: 40vh;\n        }\n    }\n\n    &_list {\n        list-style-type: disc;\n        padding-left: 5.5rem;\n\n        @media only screen and (max-width: $bp-500) {\n            padding-left: 3rem;\n        }\n\n       &>li {\n        font-size: var(--default-font-size);\n        line-height: 2.7rem;\n        margin-bottom: 2rem;\n        }\n    }\n    &_olist {\n        list-style-type: lower-alpha;\n        padding-left: 5.5rem;\n\n        @media only screen and (max-width: $bp-500) {\n            padding-left: 3rem;\n        }\n\n       &>li {\n        font-size: var(--default-font-size);\n        line-height: 2.7rem;\n        margin-bottom: 2rem;\n        }\n    }\n}\n\n.slide {\n\tmargin-top: 10rem;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, max-content);\n\tjustify-content: center;\n\tbox-sizing: border-box;  \n\n\t@media only screen and (max-width: $bp-large) {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 3rem;\n\t\tmargin-top: 4rem;\n\t}\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\tmax-width: 65rem;\n\t\tpadding-right: 2rem;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\ttext-align: center;\n\t\t}\n\n\t\t&_btn {\n\t\t\tdisplay: flex;\n\t\t\tgap: 2rem;\n            height: 2.2rem;           \n            margin: 8rem 0;\n            align-self: center;\n\n\t\t\t@media only screen and (max-width: $bp-large) {\n\t\t\t\tjustify-content: center;\n\t\t\t}\n\t\t\t@media only screen and (max-width: $bp-small) {\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n    \n\n\t&__img {\n\t\twidth: 58rem;\n\n\t\t@media only screen and (max-width: $bp-large) {\n\t\t\twidth: 40rem;\n\t\t}\n\t}\n}\n\n.btn {\n\t&__icon {\n\t\theight: 2.2rem;\t\n\t}\n}\n\n.related {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 2rem;\n\n    @media only screen and (max-width: $bp-800) {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-600) {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-400) {\n        grid-template-columns: 1fr;\n    }\n\n    &__card {\n        background-color: var(--color-white);\n        padding: 2rem;\n        border-radius: 1.6rem;\n        cursor: pointer;\n        height: 100%;\n\n        &:hover {\n            background-color: var(--color-primary-3);\n            \n        }\n\n        img {\n            width: 100%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Article_container__r+mGp`,
	"container_cards": `Article_container_cards__WxMXe`,
	"container_card": `Article_container_card__6Z7Pv`,
	"container_title": `Article_container_title__EnUTJ`,
	"container_img": `Article_container_img__PjVIn`,
	"container_list": `Article_container_list__A687y`,
	"container_olist": `Article_container_olist__GdEV5`,
	"slide": `Article_slide__Q3TM-`,
	"slide__text": `Article_slide__text__yPUhm`,
	"slide__text_btn": `Article_slide__text_btn__PGvXH`,
	"slide__img": `Article_slide__img__bOiu6`,
	"btn__icon": `Article_btn__icon__oHXr1`,
	"related": `Article_related__jV178`,
	"related__card": `Article_related__card__gi7lA`
};
export default ___CSS_LOADER_EXPORT___;
